import * as ng from 'angular';

import {Dataset, DatasetField} from '..';

ng.module('e360')
   .factory('tableChartFactory', tableChartFactory);

tableChartFactory.$inject = ['instanceServiceFactory'];
function tableChartFactory(instanceServiceFactory) {
   return instanceServiceFactory(TableChart);
}

// Requires that DataSet fields are defined and they exist in each data row
export class TableChart {
   static $inject = ['ds', '$injector'];

   thead:JQuery;
   tbody:JQuery;

   constructor(private ds:Dataset, private $injector:ng.auto.IInjectorService) {
      let container = ng.element('#' + ds.id);
      container.append('<table><thead></thead><tbody></tbody></table>');

      this.thead = container.find('thead');
      this.tbody = container.find('tbody');

      let headerRow = ng.element('<tr>');
      this.thead.append(headerRow);
      for (let field of ds.fields) {
         headerRow.append(`<th>${field.label}</th>`);
      }
   }

   setData(data:any[]) {
      this.tbody.empty();

      for (let row of data) {
         let tr = ng.element('<tr>');
         for (let field of this.ds.fields) {
            tr.append(`<td class="${field.name} ${field.type}">${this.format(field, row[field.name])}`);
         }

         this.tbody.append(tr);
      }
   }

   format(field:DatasetField, val) {
      let filterName = field.type + 'Filter';

      if (this.$injector.has(filterName)) {
         let filter = this.$injector.get(filterName) as Function;
         return filter(val);
      } else {
         return val;
      }
   }
}

export interface TableChartFactory {
   ({ds:Dataset}):TableChart;
}
